module.exports = __webpack_public_path__ + "static/media/hiw-alone2.711f68a5.svg";